import { makeStyles, createStyles } from '@material-ui/core/styles';
import background from '../assets/textura.svg';
// import backgroundLove from '../assets/background-love.png';

const useStyles = makeStyles(() =>
  createStyles({
    paperStyles: {
      backgroundImage: `url(${background})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
    },
  }),
);

export default useStyles;
